module.exports = __webpack_public_path__ + "static/media/Kasia.fea9becb.jpg";